import { useState } from "react";
import { ForecastReviewChart } from "./ForecastReviewChart";
import ForecastReviewGrid from "./ForecastReviewGrid";
import ForecastReview from "../../../../models/TradeAndPromoPlanning/ForecastReview.model";

const ForecastReviewTab = () => {
    const [forecastReviewGridRowData, setForecastReviewGridRowData] = useState<ForecastReview[]>([]);

    /**
     * Event handler on Forecast Review grid data change.
     * @param {ForecastReview[]} newGridData New Forecast Review grid data.
     * @returns {void}
     */
    const onGridDataChanged = (newGridData: ForecastReview[]): void => {
        setForecastReviewGridRowData(structuredClone(newGridData));
    }

    return (
        <div className="container-fluid">
            <ForecastReviewGrid 
                gridHeight="38vh" 
                onGridDataChanged={onGridDataChanged}
            />

            <div className="mt-2">
                <ForecastReviewChart chartHeight="38vh" gridRowData={forecastReviewGridRowData} />
            </div>
        </div>
    );
};

export default ForecastReviewTab;
